import React, { useState, forwardRef, useImperativeHandle } from 'react';

// TODO this library shoudl be changed to a new trustable one
import SwipeableViews from 'react-swipeable-views-react-18-fix';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import classes from './Tabs.module.scss';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			className={`${classes['tabs-wrapper']}`}
			{...other}>
			{value === index && <Box sx={{ my: 3 }}>{children}</Box>}
		</div>
	);
}

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		'aria-controls': `full-width-tabpanel-${index}`
	};
}

const FullWidthTabs = forwardRef(({ tabContents, onTabChange }, ref) => {
	// const [value, setValue] = useState(0);
	const [activeTab, setActiveTab] = useState(0);

	useImperativeHandle(ref, () => ({
		activeTabSetter(id) {
			const activeTabIndex = tabContents.findIndex((tab) => tab.id === id);
			window?.scrollTo({ top: 0, behavior: 'smooth' });
			setActiveTab(activeTabIndex);
		}
	}));

	const handleChange = (event, id, callback) => {
		onTabChange && onTabChange();
		window?.scrollTo({ top: 0, behavior: 'smooth' });
		setActiveTab(id);
		typeof callback === 'function' && callback();
	};

	const handleChangeIndex = (index) => {
		window?.scrollTo({ top: 0, behavior: 'smooth' });
		setActiveTab(index);
	};

	return (
		<div className="container">
			{/* <AppBar position="static"> */}
			<Tabs
				value={activeTab}
				onChange={handleChange}
				variant="fullWidth"
				aria-label="full width tabs">
				{tabContents.map((tab, index) => (
					<Tab key={tab.id} label={tab.title} {...a11yProps(index)} />
				))}
			</Tabs>
			{/* </AppBar> */}
			<SwipeableViews axis={'x'} index={activeTab} onChangeIndex={handleChangeIndex}>
				{tabContents.map((tab, index) => (
					<TabPanel style={{ overflow: 'hidden' }} key={index} value={activeTab} index={index}>
						{index === activeTab && tab.component}
					</TabPanel>
				))}
			</SwipeableViews>
		</div>
	);
});

FullWidthTabs.displayName = 'FullWidthTabs';

export default FullWidthTabs;
